import czech from "./cs";
import deutsch from "./de";
import english from "./en";
import french from "./fr";
import hungarian from "./hu";
import polish from "./pl";
import romanian from "./ro";
import slovak from "./sk";
import ukrainian from "./uk";


const translation = {
    cs : czech,
    de : deutsch,
    en : english,
    fr : french,
    hu : hungarian,
    pl : polish,
    ro : romanian,
    sk : slovak,
    uk : ukrainian
}

export default translation;
